module.exports = __webpack_public_path__ + "img/complete.44383f10.svg";